import { render, staticRenderFns } from "./GestionCandidatos.vue?vue&type=template&id=d0512e7e&scoped=true"
import script from "./GestionCandidatos.vue?vue&type=script&lang=js"
export * from "./GestionCandidatos.vue?vue&type=script&lang=js"
import style0 from "./GestionCandidatos.vue?vue&type=style&index=0&id=d0512e7e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0512e7e",
  null
  
)

export default component.exports